import { isSubscriptionShapeDigitalService } from "../../subscription-plan/selectors/isSubscriptionShape.js";
export const getSubscriptionKind = ({ type, isSeries, isBookClub, }) => {
    if (isSeries)
        return "series";
    if (isBookClub)
        return "bookClub";
    if (isSubscriptionShapeDigitalService(type))
        return "digitalService";
    // Unknown shapes have historically been treated as book subscriptions.
    return "bookSubscription";
};
